module.exports = __webpack_public_path__ + "img/19.a5a9e723.gif";